import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as styles from "./KpiGridSection.module.scss"
import { RichText } from "../RichText/RichText"

interface KpiInsightGridProps {
    title: string
    images: {
        image?: {
            gatsbyImageData: any
        }
        altText?: string
    }[]
    textSection?: {
        description?: {
            raw: string
        }
        subtitle?: string
        title?: string
        backgroundColor?: string
        textColor?: string
    }[]
}

const KpiInsightGrid: React.FC<KpiInsightGridProps> = ({ title, images, textSection = [] }) => {
    const maxLength = Math.max(images.length, textSection.length)

    return (
        <section className={`container c-padding ${styles.kpiSection}`}>
            <h2 className={`global-spacing-bottom ${styles.headingBar}`}>{title}</h2>
            <div className={styles.sectionBox}>
                {Array.from({ length: maxLength }).map((_, index) => (
                    <React.Fragment key={index}>
                        {images[index] && (
                            <div className={styles.card} key={`image-${index}`}>
                                {images[index].image?.gatsbyImageData && (
                                    <GatsbyImage
                                        image={getImage(images[index].image.gatsbyImageData)!}
                                        alt={images[index].altText || `Image ${index + 1}`}
                                    />
                                )}
                            </div>
                        )}
                        {textSection[index]?.description?.raw && (
                            <div
                                className={styles.cards}
                                key={`text-${index}`}
                                style={{
                                    backgroundColor:
                                        textSection[index].backgroundColor || "transparent",
                                    color:
                                        textSection[index].textColor || "transparent",
                                }}
                            >
                                <div className={styles.innerCard}>
                                    {
                                        textSection[index].title && (
                                            <h3 className={styles.title}>{textSection[index].title}</h3>
                                        )
                                    }
                                    <p className={styles.subTitle}>{textSection[index].subtitle}</p>
                                    <div className={styles.description}>
                                        <RichText content={textSection[index].description} />
                                    </div>
                                </div>

                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </section>
    )
}

export default KpiInsightGrid
